<app-data-setup-common-content [isIos]="true" [isTmo]="false"></app-data-setup-common-content>
<div class="att-ios-page page-section">
    <div class="phone-type-options">
        <h5>Select your Phone Type</h5>
        <div class="actions">
            <button class="button primary" (click)="fourthGen()" data-cy="fourthGen-button" id="fourthGen-button">4G
                phone</button>
            <button class="button secondary" (click)="fifthGen()" data-cy="fifthGen-button" id="fifthGen-button">5G
                phone</button>
        </div>
    </div>
</div>